module.exports = __webpack_public_path__ + "media/images/dashboard/profile-card-6c72f29d5f2a334de7767a8d01fe961e.jpg";